import * as React from "react"
import { SVGProps } from "react"
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const ExclamationMark = ({
  title,
  titleId="tm-icon-exclamation-mark",
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    {...props}
    width="1em"
    height="1em"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-hidden={!title}
    aria-labelledby={titleId}
    role={title ? "image" : ""}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath="url(#a)">
        <path fill="#A81F15" d="M24 12a12 12 0 1 1-24 0 12 12 0 0 1 24 0ZM12 6a1.357 1.357 0 0 0-1.35 1.492l.525 5.261a.828.828 0 0 0 1.65 0l.525-5.26A1.356 1.356 0 0 0 12 6Zm.003 9a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"/>
    </g>
    <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z"/>
    </clipPath>


  </svg>
)

export default ExclamationMark
